import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../ui/card";
import { LolBinTimelineData } from "../interfaces/CommonInterfaces";

export default function LolbinTimeLine({
  timelineData = [],
  loading,
}: {
  timelineData: LolBinTimelineData[];
  loading: boolean;
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Timeline</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-56">
          {loading ? (
            <div className="w-full h-full rounded-md animate-pulse bg-muted" />
          ) : timelineData.length === 0 ? (
            <div className="flex items-center justify-center h-full text-sm text-muted-foreground">
              No timeline data found.
            </div>
          ) : (
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={timelineData}>
                <CartesianGrid strokeDasharray="3 3" className="opacity-30" />
                <XAxis
                  dataKey="date"
                  axisLine={false}
                  tickLine={false}
                  tick={{ fontSize: 10 }}
                  interval={timelineData.length <= 0 ? 0 : "preserveEnd"}
                  className="text-muted-foreground"
                />
                <YAxis
                  axisLine={false}
                  tickLine={false}
                  tick={{ fontSize: 10 }}
                  className="text-muted-foreground"
                />
                <Tooltip
                  labelFormatter={(label) => `Date: ${label}`}
                  formatter={(value) => [value, "Activity"]}
                />
                <Area
                  type="monotone"
                  dataKey="activity"
                  stroke="hsl(var(--primary))"
                  fill="hsl(var(--primary) / 0.2)"
                  strokeWidth={2}
                  isAnimationActive={false}
                />
              </AreaChart>
            </ResponsiveContainer>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
